// Library
import React, { useContext } from 'react';

// Services and Contexts
import QuestionsContext from '../../../contexts/QuestionsContext';
import LanguageContext from '../../../contexts/LanguageContext';

// Material-UI
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import LinearProgress from '@material-ui/core/LinearProgress';

export default function QuestionHeader({ categoryIndex }) {
  const { questions, calculateCategoryStats } = useContext(QuestionsContext);
  const { language } = useContext(LanguageContext);
  const stats = calculateCategoryStats(questions, categoryIndex);
  const value = (stats.answered / stats.total) * 100;
  const valueLabel = `${stats.answered}/${stats.total}`;

  return (
    <Box display="flex" width="100%" alignItems="center" justifyContent="space-between">
      <Box mx={2}>
        <Typography variant="body1">{questions[categoryIndex].category[language]}</Typography>
      </Box>
      <Box display="flex" width="65%" alignItems="center">
        <Box width="100%" mr={2}>
          <LinearProgress variant="determinate" value={value} />
        </Box>
        <Box minWidth={30}>
          <Typography variant="body2" color="textSecondary">
            {valueLabel}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
